import { createSlice } from "@reduxjs/toolkit";

const serviceSlice = createSlice({
  name: "services",
  initialState: {
    serviceList: [],
    isCached: false,
    lastFetched: null,
  },
  reducers: {
    setServiceList(state, action) {
      state.serviceList = action.payload;
      state.isCached = true;  // ✅ Automatically set to true when data is saved
      state.lastFetched = Date.now();
    },
    clearServiceCache(state) {
      state.serviceList = [];
      state.isCached = false;
      state.lastFetched = null;
    },
  },
});

export const { setServiceList, clearServiceCache } = serviceSlice.actions;
export default serviceSlice.reducer;